import { Routes } from '@packages/enums';
import { AppMode } from '@ui/constants';
import { useAppMode } from '@ui/hooks';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router';
import Styles from '../Styles.module.scss';

interface SidebarLogoProps {
    collapsed: boolean;
}

type LogoConfig = {
    src: string;
    width: number;
    height: number;
};

type SidebarLogoConfig = {
    small: LogoConfig;
    large: LogoConfig;
};

const SidebarLogo: React.FC<SidebarLogoProps> = ({ collapsed }) => {
    const mode = useAppMode();

    const logosByMode: Record<AppMode, SidebarLogoConfig> = {
        [AppMode.PATIENT_JOURNEY]: {
            small: {
                src: '/logo-pji-small-light.svg',
                width: 28,
                height: 44,
            },
            large: {
                src: '/logo-pji-light.svg',
                width: 214,
                height: 44,
            },
        },
        [AppMode.PATIENT_REGISTRY]: {
            small: {
                src: '/logo-pji-small-light.svg',
                width: 28,
                height: 44,
            },
            large: {
                src: '/logo-pji-light.svg',
                width: 214,
                height: 44,
            },
        },
    };

    const { small, large } = logosByMode[mode];

    return (
        <Link
            to={Routes.HOME}
            className={Styles.logo}
            style={{ minHeight: large.height + 48 }}
        >
            <img
                src={small.src}
                alt="Logo"
                className={classNames(Styles.logoImage, collapsed ? Styles.logoVisible : Styles.logoHidden)}
                width={small.width}
                height={small.height}
            />
            <img
                src={large.src}
                alt="Logo"
                className={classNames(Styles.logoImage, !collapsed ? Styles.logoVisible : Styles.logoHidden)}
                width={large.width}
                height={large.height}
            />
        </Link>
    );
};

export default React.memo(SidebarLogo);
